import { matchPath, useLocation } from "react-router-dom";
import { ROUTES_WITHOUT_APP_BAR, ROUTES_WITH_DIVIDER } from "../AppBarHeader.constants";
import { useEffect } from "react";
import useAppBarState from "../../hook/useAppBarState";
import { AppBarHeaderProps } from "../AppBarHeader";
import { HeaderProps } from "../../../Header/Header.types";

export interface UseAppBarHeaderReturn {
    divider: boolean;
    left: HeaderProps["left"];
    onLeftClick: HeaderProps["onLeftClick"];
    hide: boolean;
}

export default function useAppBarHeader({ onLeftClick }: Pick<AppBarHeaderProps, "onLeftClick">): UseAppBarHeaderReturn {
    const location = useLocation();
    const [{ activeBg }, setActiveBg] = useAppBarState();

    useEffect(() => {
        if (activeBg) setActiveBg({ activeBg: false });
    }, [location]);

    function handleLeftClick() {
        onLeftClick?.();
    }

    return {
        divider: ROUTES_WITH_DIVIDER.some((path) => matchPath(path, location.pathname)),
        left: "menu",
        onLeftClick: handleLeftClick,
        hide: ROUTES_WITHOUT_APP_BAR.some((path) => matchPath(path, location.pathname)),
    };
}
